import React, { useState, FormEvent } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { AppState } from '../../../reducers/index'
import { SuccessLabel } from '../../Utils/ShowLabel'
import { updateCredentials as sendNewCredentials } from '../../../actions/auth/updateCredentials'
import { fetchSession } from '../../../actions/auth/session'
import ProgressButton from '../../Utils/ProgressButton'
import NewPassword from '../../Utils/NewPassword'
import { Paper, Container, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'

const Credentials: React.FC<StateProps> = ({ session, updateCredentials }) => {
  const [oldPassword, setOldPassword] = useState<string | undefined>(undefined)
  const [newPassword, setNewPassword] = useState<string | null>(null)
  const [changed, setChanged] = useState<boolean>(false)

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation('menu')

  const changeCredentials = (event: FormEvent) => {
    event.preventDefault()
    dispatch(sendNewCredentials({ oldPassword: oldPassword!, newPassword: newPassword! }, () => {
      if (session.shouldUpdatePassword) dispatch(fetchSession(history, location, t('home')))
    setChanged(true)
    })(location.search))
  }

  return (
    <Container>
      <Paper style={{borderRadius: "10px", margin: "10px"}}>
      <ISTableTitle title={t('credentials')}/>
        <Paper style={{padding: "10px"}}>
        <form onSubmit={changeCredentials}>
          <TextField
            label={t('currentPassword')}
            margin="normal"
            variant="outlined"
            type="password"
            onChange={event => setOldPassword(event.target.value)}
            fullWidth
            size="small"
            required
          />
          <NewPassword onValidPassword={setNewPassword}/>
          <ProgressButton state={updateCredentials} disabled={!newPassword}>
             {t('updatePassword')}
          </ProgressButton>
          <SuccessLabel
            show={updateCredentials.updated && changed}
            message={t('updatedPassword')}
          />
        </form>
      </Paper>
    </Paper>
    </Container>
  )
}

type StateProps = ReturnType<typeof mapStateToProps>
const mapStateToProps = ({ session, updateCredentials }: AppState) => ({ session, updateCredentials })

export default connect<StateProps, {}, {}, AppState>(mapStateToProps)(Credentials)
